import Vue from 'vue'
import Alert from './alert'

const vm = new Vue()

const DuiMessage = {
  defaultPageSize: 20, // 默认每页消息数目
  unreadInterval: 10000, // 轮询未读消息间隔
  // newestMsgTime: 0,
  newestMsgIdList: [],
  getNewestMsgIdList: function (argument) {
    let newestMsgIdList = JSON.parse(window.localStorage.getItem('newestMsgIdList'))
    if (typeof newestMsgIdList === 'string') {
      newestMsgIdList = newestMsgIdList.replace(/[\[\]]/g, '')
      newestMsgIdList = newestMsgIdList.split(',')
    }
    return newestMsgIdList
  },
  rememberNewestMsgIdList: function (idList) { // 记住最新未读消息id列表
    const newestMsgIdList = JSON.stringify(idList.slice(0, 5))
    window.localStorage.setItem('newestMsgIdList', newestMsgIdList)
  },
  // 获取未读消息数量，显示最新5条未读消息
  getUnreadMessageNum: function ({
    dispatch,
    commit,
    state
  }) {
    vm.$http.get(`/console/api/v1.0/messages/unreadNum`).then((response) => {
      if (response.body.errId === 0) {
        commit('GET_UNREAD_MESSAGES_NUM', response.body.num)
        // if (response.body.num) {
        //   const messages = response.body.result.messages
        //   const filter = messages.filter(item => !item.notifyStatus)
        //   const unNotifyList = filter.length ? filter.slice(0, 5) : []
        //   // const newestMsgTime = DuiMessage.getNewestMsgTime()
        //   const diff = DuiMessage.getDiffentMsg(messages, state.message.unreadList)
        //   // DuiMessage.newestMsgTime = newestMsgTime
        //   diff.length && diff.map((item) => {
        //     if (item.messageId) {
        //       dispatch('getMessageContent', {
        //         messageId: item.messageId,
        //         index: item.index,
        //         notify: unNotifyList.filter(msg => msg.messageId === item.messageId).length
        //       })
        //     } else {
        //       commit('GET_MESSAGE_CONTENT', {
        //         messageCont: '',
        //         index: item.index
        //       })
        //     }
        //   })
        //   unNotifyList.length && unNotifyList.map(item => {
        //     const filter = diff.filter(msg => msg.messageId === item.messageId)
        //     if (!filter.length) {
        //       dispatch('getMessageContent', {
        //         messageId: item.messageId,
        //         index: null,
        //         notify: true
        //       })
        //     }
        //   })
        //   DuiMessage.rememberNewestMsgIdList(messages)
        // }
      } else {
        if (state.message.unreadList.length) {
          commit('INIT_UNREADLIST')
        }
      }
    }, (response) => {})
  },
  // 获取指定消息的内容
  getMessageContent: function ({
    dispatch,
    commit
  }, {
    messageId,
    index,
    notify
  }) {
    vm.$http.get(`api/v1.0/messages/content/${messageId}`).then((response) => {
      if (response.body.errId === 0) {
        const messageCont = response.body.result
        // const dateNew = DuiMessage.getTimeStamp(messageCont.createTime)
        // const date = DuiMessage.getTimeStamp(DuiMessage.newestMsgTime)
        if (index !== null) {
          commit('GET_MESSAGE_CONTENT', {
            messageCont: messageCont,
            index: index
          })
        }
        if (notify) {
          vm.$notify.info({
            customClass: 'ai-notify--msg',
            message: messageCont.title,
            onClick: () => {
              window.location = '/console/message.html#/' + messageCont.messageId
              dispatch('setMessageReaded', { messageIds: [messageCont.messageId] })
              // DuiMessage.clickNotifyMsg(dispatch, messageCont)
            },
            offset: 50
          })
        }
      } else {
        Alert({
          type: 'error',
          message: response.body.error
        })
      }
    }, (response) => {})
  },
  // 将消息标记为已读
  setMessageReaded: function ({
    dispatch,
    commit
  }, { messageIds }) {
    vm.$http.put(`api/v1.0/messages/mark`, JSON.stringify({
      messageIds: messageIds
    })).then((response) => {
      if (response.body.errId === 0) {
        commit('INIT_UNREADLIST', messageIds)
        dispatch('getUnreadMessageNum')
        Alert({
          type: 'success',
          message: '标记为已读成功！'
        })
      } else {
        Alert({
          type: 'error',
          message: response.body.error
        })
      }
    }, (response) => {})
  },
  getTimeStamp (time) {
    const date = time ? new Date(time.replace(/-/g, '/')) : 0
    const timeStamp = date ? date.getTime() : 0
    return timeStamp
  },
  getDiffentMsg (messages, unreadList) {
    let result = []
    for (let i = 0; i < 5; i++) {
      if (unreadList[i] && messages[i].messageId === unreadList[i].messageId) {
        continue
      } else if (unreadList[i] === '' && messages[i] === undefined) {
        continue
      } else {
        result.push({
          index: i,
          messageId: messages[i] ? messages[i].messageId : ''
        })
      }
    }
    return result
  },
  clickNotifyMsg (dispatch, message) {
    window.location = '/console/message.html#/' + message.messageId
    dispatch('setMessageReaded', { messageIds: [message.messageId] })
  },
  _interalRun: function (dispatch) {
    dispatch('getUnreadMessageNum')
  },
  interalRun: function (dispatch) {
    const that = this
    return function () {
      that._interalRun(dispatch)
    }
  }
}

module.exports = DuiMessage



// WEBPACK FOOTER //
// ./src/utils/message.js